// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"timer_timer-container__2nNio"};